import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { UserGuard } from './core/guards/user.guard';

const routes: Routes = [
  // Redirect empty URL to /dashboard
  {
    path: '',
    redirectTo: 'settings/core',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  {
    path: 'settings',
    canActivate: [AuthGuard, UserGuard],
    loadChildren: () =>
      import('./settings/settings.module').then((m) => m.SettingsModule),
  },
  {
    path: 'dff',
    canActivate: [AuthGuard, UserGuard],
    loadChildren: () => import('./dff/dff.module').then((m) => m.DffModule),
  },
  {
    path: 'sff',
    canActivate: [AuthGuard, UserGuard],
    loadChildren: () => import('./sff/sff.module').then((m) => m.SffModule),
  },
  {
    path: 'accounts',
    canActivate: [AuthGuard, UserGuard],
    loadChildren: () =>
      import('./accounts/accounts.module').then((m) => m.AccountsModule),
  },
  {
    path: 'users',
    canActivate: [AuthGuard, UserGuard],
    loadChildren: () =>
      import('./users/users.module').then((m) => m.UsersModule),
  },
  {
    path: 'assets',
    canActivate: [AuthGuard, UserGuard],
    loadChildren: () =>
      import('./rft-assets/rft-assets.module').then((m) => m.RftAssetsModule),
  },
  {
    path: 'notification',
    canActivate: [AuthGuard, UserGuard],
    // Ensure NotificationModule is the correct export name
    loadChildren: () =>
      import('./notification/notification.module').then(
        (m) => m.RftNotificationModule,
      ),
  },
  {
    path: 'subscription',
    canActivate: [AuthGuard, UserGuard],
    // Ensure SubscriptionModule is the correct export name
    loadChildren: () =>
      import('./subscription/subscription.module').then(
        (m) => m.RftSubscriptionModule,
      ),
  },
  {
    path: 'survey',
    canActivate: [AuthGuard, UserGuard],
    loadChildren: () =>
      import('./survey/survey.module').then((m) => m.SurveyModule),
  },
  {
    path: 'refer-earn',
    canActivate: [AuthGuard, UserGuard],
    loadChildren: () =>
      import('./refer-earn/refer-earn.module').then((m) => m.ReferEarnModule),
  },
  {
    path: 'brands',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./brand/brand.module').then((m) => m.BrandModule),
  },
  // Wildcard route for a 404 page or redirect
  {
    path: '**',
    redirectTo: 'settings/core',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
